/* eslint-disable operator-linebreak */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import HighChartGraph, { ApiHandler as HC, HighChartOptions } from 'wdna-highchart';

import { emptyData, getDateFormat } from 'wdna-components/lib/helpers/highchart';

import pressets, { CARDINALS } from './pressets';

interface Props {
  title: string;
  data: any[];
}

type State = unknown;

export default class ChartWindRoseSingle extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  public getOptions = (graphInput: any = {}): any => {
    const { title } = this.props;
    const { axisX } = getDateFormat(graphInput?.groupDateTime);

    const options: HighChartOptions = _.cloneDeep(pressets.spline2);
    if (options.xAxis?.[0]) {
      options.xAxis[0].tickmarkPlacement = 'on';
      options.xAxis[0].labels.rotation = 0;
      options.xAxis[0].type = 'categories';
      options.xAxis[0].categories = CARDINALS;
    }

    const hc: HC = new HC(options);
    hc.setXAxisFormat(axisX);
    hc.setOption('title.text', `<b>${title}</b>`);
    hc.setOption('chart.polar', true);
    hc.setOption('plotOptions.series.pointPlacement', 'on');
    hc.setOption('plotOptions.series.stacking', 'normal');
    hc.setOption('exporting.enabled', false);

    return options;
  };

  public degToCompass = (register?: Record<string, number>): number[] => {
    const arr: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    if (register) {
      const val: number = Math.floor((register.d00 / 22.5) + 0.5);
      const pos: number = CARDINALS.indexOf(CARDINALS[(val % 16)]);
      if (pos > -1) arr.splice(pos, 1, 1);
    }

    return arr;
  };

  public render(): JSX.Element {
    const { data } = this.props;
    const options: any = this.getOptions();

    const dgraph: any[] = [{
      name: 'Wind Position',
      data: this.degToCompass(data?.[0]),
      type: 'column',
      yAxis: 0,
      zIndex: 2,
    }];

    const style: React.CSSProperties = { height: 'calc(24vh)', minHeight: '100px', maxHeight: '250px' };
    return (
      <div style={style}>
        <HighChartGraph data={dgraph || emptyData} options={options} settings />
      </div>
    );
  }
}
